/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */

import SouscriptionWaiverStages from './souscriptionWaiverStages/client/SouscriptionWaiverStages';
import SouscriptionSupportingDocuments from './souscriptionSupportingDocuments/client/SouscriptionSupportingDocuments';
import SouscriptionRecap from './souscriptionRecap/client/SouscriptionRecap';
import SouscriptionPricing from './souscriptionPricing/client/SouscriptionPricing';
import SouscriptionPaymentRefund from './souscriptionPaymentRefund/client/SouscriptionPaymentRefund';
import SouscriptionInformations from './souscriptionInformations/client/SouscriptionInformations';
import SouscriptionCustomerGrantees from './souscriptionCustomerGrantees/client/SouscriptionCustomerGrantees';
import SouscriptionCompany from './souscriptionCompany/client/SouscriptionCompany';
import SouscriptionActivePolicy from './souscriptionActivePolicy/client/SouscriptionActivePolicy';
import SimulationRecap from './simulationRecap/client/SimulationRecap';
import SimulationProduct from './simulationProduct/client/SimulationProduct';
import SimulationPricingsSelfWorker from './simulationPricingsSelfWorker/client/SimulationPricingsSelfWorker';
import SimulationPricingsIndividualHealth from './simulationPricingsIndividualHealth/client/SimulationPricingsIndividualHealth';
import SimulationPricingGroupHealth from './simulationPricingGroupHealth/client/SimulationPricingGroupHealth';
import SimulationPricingsDailyBenefit from './simulationPricingsDailyBenefit/client/SimulationPricingsDailyBenefit';
import SimulationPavillonInformation from './simulationPavillonInformation/client/SimulationPavillonInformation';
import SimulationNeeds from './simulationNeeds/client/SimulationNeeds';
import SimulationEffectDate from './simulationEffectDate/client/SimulationEffectDate';
import SimulationDemography from './simulationDemography/client/SimulationDemography';
import SimulationCustomerGrantees from './simulationCustomerGrantees/client/SimulationCustomerGrantees';
import SimulationCompany from './simulationCompany/client/SimulationCompany';

const views = {

  SOUSCRIPTION_WAIVER_STAGES: SouscriptionWaiverStages,
  SOUSCRIPTION_SUPPORTING_DOCUMENTS: SouscriptionSupportingDocuments,
  SOUSCRIPTION_RECAP: SouscriptionRecap,
  SOUSCRIPTION_PRICING: SouscriptionPricing,
  SOUSCRIPTION_PAYMENT_REFUND: SouscriptionPaymentRefund,
  SOUSCRIPTION_INFORMATIONS: SouscriptionInformations,
  SOUSCRIPTION_CUSTOMER_GRANTEES: SouscriptionCustomerGrantees,
  SOUSCRIPTION_COMPANY: SouscriptionCompany,
  SOUSCRIPTION_ACTIVE_POLICY: SouscriptionActivePolicy,
  SIMULATION_RECAP: SimulationRecap,
  SIMULATION_PRODUCT: SimulationProduct,
  SIMULATION_PRICINGS_SELF_WORKER: SimulationPricingsSelfWorker,
  SIMULATION_PRICINGS_INDIVIDUAL_HEALTH: SimulationPricingsIndividualHealth,
  SIMULATION_PRICINGS_GROUP_HEALTH: SimulationPricingGroupHealth,
  SIMULATION_PRICINGS_DAILY_BENEFIT: SimulationPricingsDailyBenefit,
  SIMULATION_PAVILLON_INFORMATION: SimulationPavillonInformation,
  SIMULATION_NEEDS: SimulationNeeds,
  SIMULATION_EFFECT_DATE: SimulationEffectDate,
  SIMULATION_DEMOGRAPHY: SimulationDemography,
  SIMULATION_CUSTOMER_GRANTEES: SimulationCustomerGrantees,
  SIMULATION_COMPANY: SimulationCompany
};

export default views;
